module.exports = __webpack_public_path__ + "static/img/ex-product-display-1.b1a19e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/ex-product-display-1.png
// module id = YJrY
// module chunks = 134